/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_Row_HintInputs */

const en_us2_plan_edit_row_hint = /** @type {(inputs: Plan_Edit_Row_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to see the exercise. ⋯ swaps or removes; Edit reorders and adds.`)
};

const pt_br2_plan_edit_row_hint = /** @type {(inputs: Plan_Edit_Row_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque para ver o exercício. ⋯ troca ou remove; Editar reordena e adiciona.`)
};

const es_419_plan_edit_row_hint = /** @type {(inputs: Plan_Edit_Row_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca para ver el ejercicio. ⋯ cambia o quita; Editar reordena y agrega.`)
};

const pt_pt2_plan_edit_row_hint = /** @type {(inputs: Plan_Edit_Row_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca para ver o exercício. ⋯ troca ou remove; Editar reordena e adiciona.`)
};

const fr_fr2_plan_edit_row_hint = /** @type {(inputs: Plan_Edit_Row_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Touche pour voir l'exercice. ⋯ change ou retire ; Modifier réordonne et ajoute.`)
};

const de_de2_plan_edit_row_hint = /** @type {(inputs: Plan_Edit_Row_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe, um die Übung zu sehen. ⋯ tauscht oder entfernt; Bearbeiten sortiert und fügt hinzu.`)
};

const it_it2_plan_edit_row_hint = /** @type {(inputs: Plan_Edit_Row_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca per vedere l'esercizio. ⋯ cambia o rimuove; Modifica riordina e aggiunge.`)
};

/**
* | output |
* | --- |
* | "Tap to see the exercise. ⋯ swaps or removes; Edit reorders and adds." |
*
* @param {Plan_Edit_Row_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_row_hint = /** @type {((inputs?: Plan_Edit_Row_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Row_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_row_hint(inputs)
	if (locale === "es-419") return es_419_plan_edit_row_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_row_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_row_hint(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_row_hint(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_row_hint(inputs)
	return en_us2_plan_edit_row_hint(inputs)
});
export { plan_edit_row_hint as "plan-edit.row_hint" }